<template>
    <div>
        <!-- <my-search @search="searchHandler" v-model="pgData" >
            <el-form-item slot="time">
                <el-input type="text" v-model="pgData.bdcode" placeholder="请输入标段名称/标段编号" clearable></el-input>
            </el-form-item>
            <el-form-item slot="title">
                
            </el-form-item>
            <template slot="btn">
            
            </template>
        </my-search> -->
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段名称" prop="bdname" min-width="220" fixed="left"></el-table-column>
            <el-table-column label="标段编码" prop="bdcode" min-width="160"></el-table-column>
          
            <el-table-column label="评价信息" min-width="110" fixed="right">
                <template slot-scope="scope">
                    <btn-list 
                        :row="scope.row"
                        @reload="reloadHandler"
                        @getTk="getTk(scope.row)"
                        @getDetail="getDetail(scope.row)"
                        @getEdit="getEdit(scope.row)"
                        :config="BTN_CONF">
                    </btn-list>
                </template>
                
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('mngUrl')}/service/pj/get_list.json`">
        </my-pagination>
        <!-- <my-dialog 
        v-model="dialogVisible" 
        width="1000px" 
        title="服务评价"
        > -->
            <Form v-if="xianshi==true" :xianshi="xianshi" :bdcode="bdcode" :bdname="bdname" :zbprocode="getQuery('procode')" :zbproname="zbproname"  @close="close"></Form>
            <Detail v-if="detail_xianshi==true" :xianshi="detail_xianshi" :bdcode="bdcode"   @closeDetail="closeDetail"></Detail>
            <Edit v-if="edit_xianshi==true" :xianshi="edit_xianshi" :bdcode="bdcode" :bdname="bdname" :zbprocode="getQuery('procode')" :zbproname="zbproname"  @closeEdit="closeEdit"></Edit>
            <div class="v-modal" tabindex="0" style="z-index:2075"></div>
        <!-- </my-dialog> -->
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'
import BTN_CONF from './config/btn-list'
import Form from './components/form.vue'
import Detail from './components/detail.vue'
import Edit from './components/edit.vue'
export default {
    mixins: [LIST_PAGE_MIXIN,DIALOG_LIST_PAGE_MIXIN],
    components: {Form,Detail,Edit},

    data() {
        return{
            pgData:{
                bdcode:'',
                procode:this.getQuery('procode'),
                sortname:'ggcode'
            },
            dialogVisible:false,
            BTN_CONF,
            xianshi:false,
            detail_xianshi:false,
            edit_xianshi:false,
            bdcode:'',
            zbprocode:'',
            zbproname:'',
            bdname:''
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        getTk(val) {
            this.bdcode=val.bdcode
            this.bdname=val.bdname
            this.zbprocode=val.zbprocode
            this.zbproname=val.zbproname
            this.xianshi=true
            $(".v-modal ").css("display","block");
    
        },
        getDetail(val) {
            this.bdcode=val.bdcode
            this.detail_xianshi=true
            $(".v-modal ").css("display","block");
        },
        getEdit(val) {
            this.bdcode=val.bdcode
            this.bdname=val.bdname
            this.zbprocode=val.zbprocode
            this.zbproname=val.zbproname
            this.edit_xianshi=true
            $(".v-modal ").css("display","block");
    
        },
        close(val) {
            this.xianshi=val
            $(".v-modal ").css("display","none");
            this.reloadHandler()
        },
        closeDetail(val) {
            this.detail_xianshi=val
            $(".v-modal ").css("display","none");
            this.reloadHandler()
        },
        closeEdit(val) {
            this.edit_xianshi=val
            $(".v-modal ").css("display","none");
            this.reloadHandler()
        },
    },
    created() {
       
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
.v-modal {
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000000;
}

</style>
